export interface Position {
  lat: number
  lng: number
  accuracy: number
}

/**
 * One position fix at the moment of completion, never a watch. Gives up after
 * `timeoutMs` so a bad signal in the cellar never holds up the checkmark.
 */
export function currentPosition(timeoutMs = 6000): Promise<Position | null> {
  if (!('geolocation' in navigator)) return Promise.resolve(null)
  return new Promise((resolve) => {
    const timer = setTimeout(() => resolve(null), timeoutMs + 500)
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        clearTimeout(timer)
        resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude, accuracy: pos.coords.accuracy })
      },
      () => {
        clearTimeout(timer)
        resolve(null)
      },
      { enableHighAccuracy: true, timeout: timeoutMs, maximumAge: 60_000 },
    )
  })
}
